// LearnedPill — pill DISCRETA no chat que avisa o self-improvement por-sessão.
// Pedido do Pedro: "badge no chat discreto como pill" + "pill SEMPRE dá feedback"
// (2026-07-09) — antes só aparecia quando promovia/detectava algo, então num run
// limpo NUNCA aparecia (a queixa "não avisa nada"). Agora, quando o loop rodou de
// fato mas não achou nada novo (detected=promoted=0), mostra "Revisei esta sessão
// · nada novo" (variante mais apagada). Some só quando o loop NÃO rodou
// (learned=null: throttled/desligado). Dispensável no X.
//
// Fonte: useSessionLearned (soma os session_learned da sessão). Clicar abre a
// aba Evaluator (regras aprendidas) via evento.

import { Brain, X } from 'lucide-react';

function plural(n, one, many) {
  return `${n} ${n === 1 ? one : many}`;
}

export default function LearnedPill({ learned, onDismiss }) {
  // learned=null ⇒ o loop não rodou nesta sessão (throttled/desligado) → nada a mostrar.
  if (!learned) return null;
  const detected = learned.detected || 0;
  const promoted = learned.promoted || 0;
  const hasLearning = detected > 0 || promoted > 0;

  const parts = [];
  if (promoted > 0) parts.push(plural(promoted, 'regra', 'regras'));
  if (detected > 0) parts.push(plural(detected, 'padrão', 'padrões'));
  const label = hasLearning
    ? `Aprendi nesta sessão · ${parts.join(' · ')}`
    : 'Revisei esta sessão · nada novo';

  return (
    <span
      className={`rx-learned-pill${hasLearning ? '' : ' rx-learned-pill--empty'}`}
      data-testid="learned-pill"
      data-empty={hasLearning ? undefined : 'true'}
      role="status"
    >
      <button
        type="button"
        className="rx-learned-pill-main"
        title={hasLearning ? 'Ver regras aprendidas (Evaluator)' : 'Loop de aprendizado rodou · ver Evaluator'}
        onClick={() => window.dispatchEvent(new CustomEvent('apolo:openLearnedRules'))}
      >
        <Brain size={12} aria-hidden="true" />
        {label}
      </button>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dispensar"
        title="Dispensar"
        className="rx-learned-pill-x"
      >
        <X size={11} aria-hidden="true" />
      </button>
    </span>
  );
}
